import Swal from 'sweetalert2';
import { burnNFT } from '../../SmartContract/burnNFT';
import { blockchainService } from '../../../../services/blockchainService';

export async function cancelarFile(
  guid,
  __file_manager_nft_dt,
  __visible_show_nft,
  file_manager_control_id,
  headers,
  contract_contract_address_client,
  contract_wallet_owner,
  modelo_GUID,
  project_id,
  setData2,
  setFileStates,
  setBotaoSalvar
) {
  try {
    const result = await Swal.fire({
      title: 'Confirmação',
      html: `
        <div>
          <label for="justificativa">Justificativa:</label>
          <textarea style="width: 400px; height: 100px;" id="ctl00_ContentPlaceHolder1_txtJustificativa" 
            class="swal2-input" required></textarea>
        </div>
        <div>
          <label for="senha">Senha:</label>
          <input type="password" id="ctl00_ContentPlaceHolder1_txtSenha" autocomplete="off" 
            style="width:200px;" class="swal2-input password-input">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Confirmar Cancelamento',
      cancelButtonText: 'Cancelar',
      focusConfirm: false,
      preConfirm: () => {
        const senha = Swal.getPopup().querySelector('#ctl00_ContentPlaceHolder1_txtSenha').value;
        const justificativa = Swal.getPopup().querySelector('#ctl00_ContentPlaceHolder1_txtJustificativa').value;
        if (!senha || !justificativa) {
          Swal.showValidationMessage(`Preencha justificativa e senha`);
          return false;
        }
        return { senha, justificativa };
      },
    });

    if (!result.isConfirmed) return;

    // Cancela o documento via service
    await blockchainService.cancelDocument(
      guid,
      result.value.senha,
      result.value.justificativa,
      headers
    );

    // Se o documento possui NFT ativo e visível
    if (__visible_show_nft && contract_contract_address_client) {
      try {
        const retorno = await burnNFT(
          contract_contract_address_client,
          contract_wallet_owner,
          __file_manager_nft_dt.nft_token_id,
          __file_manager_nft_dt.nft_file_manager_nft_id
        );

        await blockchainService.atualizarJsonResponseNftBurned(
          retorno.file_manager_nft_id,
          retorno,
          retorno.contratoAddress,
          retorno.contratoClienteAddress,
          retorno.signerGeral,
          retorno.tokenId,
          retorno.signer,
          retorno.signature,
          retorno.hashedMessage
        );

        await blockchainService.atualizarDataNftBurned(retorno);
        await blockchainService.atualizarNftButtonBurned(file_manager_control_id);

        Swal.fire({
          title: 'Sucesso!',
          text: 'NFT - Burned executado com sucesso!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
      } catch (error) {
        console.error('Erro no burnNFT:', error);
        await blockchainService.atualizaCampoErroNftBurn(
          __file_manager_nft_dt.nft_file_manager_nft_id,
          error.signer,
          error.signature,
          error.hashedMessage,
          error
        );
        Swal.fire({
          title: 'Erro!',
          text: 'Algo deu errado ao criar a NFT. Contate suporte!',
          icon: 'error',
          confirmButtonText: 'OK',
        });
        return;
      }
    } else {
      Swal.fire({
        title: 'Sucesso!',
        text: 'Documento cancelado com sucesso!',
        icon: 'success',
        confirmButtonText: 'OK',
      });
    }

    // Atualiza os dados da tela usando o service
    const modelData = await blockchainService.getDocumentModelData(modelo_GUID, project_id, headers);
    setData2({ ...modelData });
    setFileStates({});
    setBotaoSalvar(false);

  } catch (error) {
    console.error('Erro ao cancelar documento:', error);
    Swal.fire({
      title: 'Erro!',
      text: error.response?.data?.message || 'Ocorreu um erro ao cancelar o documento.',
      icon: 'error',
      confirmButtonText: 'OK',
    });
  }
}

